<script lang="ts">
	import { Card, ProductComposite } from "@hitit/new_ui";
	import { t } from "@hitit/hub/src/stores";
	import { getT } from "@hitit/utils";
	import { formatKrwNumber } from "../../../utils";
	import type StoreItem from "../../../class/StoreItem/StoreItem";

	export let item: StoreItem;

</script>

<div class="container">
	<Card noPadding>
		<div class="wrapper">
			<ProductComposite
				name={$t('global.product.name')}
				value={getT(item.getTranslation(), 'name', 'ko')} />
			<ProductComposite
				name={$t('global.product.price')}
				value={formatKrwNumber(item.getPrice())} />
			<ProductComposite
				name={$t('global.product.description')}
				value={getT(item.getTranslation(), 'description', 'ko')} />
			<ProductComposite name={$t('global.product.add_option')}>
				<div class="options" slot="value">
					{#each item.getOptionCollectionDTOs() as option}
						<p>{getT(option.getTranslations(), 'name', 'ko')}</p>
					{:else}
						<p>-</p>
					{/each}
				</div>
			</ProductComposite>
			<ProductComposite
				name={$t('global.product.stock')}
				value={item.getStockAvailable() ? String(item.getStock()) : '-'} />
			<ProductComposite
				name={$t('global.product.barcode')}
				defaultPlaceholdValue={'-'} />
			<!-- {#if item.getBarcodeAvailable()}
					<div class="barcode" />
				{/if} -->

			<ProductComposite
				name={$t('global.product.place_enabled')}
				value={item.placeEnabled ? $t('hub.store.widget.cashreceipt.enabled') : $t('hub.store.widget.cashreceipt.disabled')} />
		</div>
	</Card>
</div>

<style lang="scss">
	@import "../../../../variables.scss";

	.container {
		display: flex;
		width: 100%;
		flex-direction: column;
	}

	.wrapper {
		display: flex;
		flex-direction: column;
		width: 100%;
		padding: 20px 10px;
		gap: 20px;

		.options {
			display: flex;
			flex-direction: column;
			gap: 10px;
		}
	}

	@include DesktopSize {
		.wrapper {
			padding: 30px;
		}
	}

</style>
